/** @jsxImportSource @emotion/react */
import type { Theme } from "@emotion/react";
import styled from "@emotion/styled";
import {
  Button,
  Container,
  H2,
  Input,
  Label,
  Link,
  NavLink,
  Text,
} from "atoms";
import { constants } from "config";

const css = {
  newsletter: (theme: Theme) => ({
    background: theme.colors.primary,
    nav: {
      borderTop: `1px solid ${theme.colors.fg}`,
      marginTop: "2rem",
      paddingTop: "2rem",
      "a:not(:last-of-type)": {
        marginBottom: "1rem",
      },
      "@media (min-width: 960px)": {
        border: 0,
        paddingTop: 0,
        marginTop: ".5rem",
        width: "30%",
      },
    },
    form: {
      label: {
        marginBottom: "1rem",
        textAlign: "left" as const,
      },
      input: {
        width: "100%",
      },
      "@media (min-width: 750px)": {
        display: "flex",
        alignItems: "flex-end",
        label: {
          flex: 1,
          margin: "0 0.6rem 0 0",
        },
      },
    },
  }),
  marginTop: {
    marginTop: "1em",
  },
};

function Newsletter() {
  return (
    <aside css={css.newsletter} id="newsletter">
      <SContainer>
        <div>
          <H2>Get hugs in your&nbsp;inbox.</H2>
          <Text size="sm">
            Stay up to date on special announcements, launches, and&nbsp;more!
          </Text>

          <form
            action="https://www.getrevue.co/profile/thehugxyz/add_subscriber"
            method="post"
            name="revue-form"
            target="_blank"
          >
            <Label>
              Email:
              <Input
                bordered={false}
                placeholder="hi@thehug.xyz"
                type="email"
                name="member[email]"
                id="member_email"
              />
            </Label>
            <Button type="submit" variant="gradient" size="md">
              Subscribe
            </Button>
          </form>

          <PrivacyText size="xs">
            By providing your email address, you agree to our{" "}
            <Link to="/privacy-policy">Privacy Policy</Link>.
          </PrivacyText>
        </div>

        <nav>
          <SNavLink to="/faq">FAQ</SNavLink>
          <SNavLink to="/about">About</SNavLink>
          <SNavLink href={constants.openseaURL}>View on OpenSea</SNavLink>
          <SNavLink href={constants.discordURL}>Join the Discord</SNavLink>
          <SNavLink href={constants.twitterURL}>Follow Us @thehugxyz</SNavLink>
        </nav>
      </SContainer>
    </aside>
  );
}

const SContainer = styled(Container)(
  {
    paddingTop: "4rem",
    paddingBottom: "3rem",
    textAlign: "center",
    "@media (min-width: 960px)": {
      alignItems: "top",
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      textAlign: "left",
      "& > div": {
        marginRight: "2rem",
      },
    },
  },
  ({ theme }) => ({
    "& > div": {
      "a:hover, a:focus-visible": {
        color: theme.colors.yellow,
      },
    },
  })
);

const SNavLink = styled(NavLink)(({ theme }) => ({
  ...theme.fonts.body,
  fontSize: theme.fontSizes.sm,
  fontWeight: "bold",
  textTransform: "none",
}));
const PrivacyText = styled(Text)({
  marginTop: ".5rem",
});

export { Newsletter };
